import type { FC, ReactNode } from "react";
import {
  ActionIcon,
  Button,
  Card,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconAlertCircle, IconSend, IconX } from "@tabler/icons-react";
import { ICON_STROKE } from "./order-page-v2.utils";

export const REQUEST_ERROR_MESSAGE =
  "La demande n'a pas pu être envoyée. Réessayez, ou contactez votre conseiller Jasper.";

type OrderRequestPanelProps = {
  title: string;
  subtitle: string;
  hint?: string;
  errorMessage?: string | null;
  submitLabel?: string;
  isSubmitting?: boolean;
  onSubmit?: () => void;
  onClose: () => void;
  children: ReactNode;
};

export const OrderRequestPanel: FC<OrderRequestPanelProps> = ({
  title,
  subtitle,
  hint,
  errorMessage,
  submitLabel,
  isSubmitting = false,
  onSubmit,
  onClose,
  children,
}) => (
  <Card
    withBorder
    p="s5"
    shadow="xs"
    style={{ borderColor: "var(--mantine-color-brand-1)" }}
  >
    <Stack gap="s4">
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Stack gap="s1">
          <Title order={3}>{title}</Title>
          <Text size="sm">{subtitle}</Text>
        </Stack>
        <ActionIcon
          variant="subtle"
          color="ink"
          size="lg"
          aria-label="Fermer"
          onClick={onClose}
        >
          <IconX size={16} stroke={ICON_STROKE} />
        </ActionIcon>
      </Group>
      {children}
      {errorMessage && (
        <Group gap="s1" wrap="nowrap" role="alert">
          <IconAlertCircle
            size={14}
            stroke={ICON_STROKE}
            color="var(--mantine-color-danger-7)"
          />
          <Text size="sm" c="danger.7">
            {errorMessage}
          </Text>
        </Group>
      )}
      {(hint || (onSubmit && submitLabel)) && (
        <Group justify="space-between" gap="s3">
          <Text variant="caption">{hint}</Text>
          {onSubmit && submitLabel && (
            <Button
              size="sm"
              leftSection={<IconSend size={14} stroke={ICON_STROKE} />}
              loading={isSubmitting}
              onClick={onSubmit}
            >
              {submitLabel}
            </Button>
          )}
        </Group>
      )}
    </Stack>
  </Card>
);
